// extracted by mini-css-extract-plugin
export default {"tabs-header":"TabsHeaderStyles_tabs-header__8Soy5"};